import { render, staticRenderFns } from "./OrganizationProfile.vue?vue&type=template&id=7a19d530&scoped=true"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a19d530",
  null
  
)

export default component.exports